export default "__VITE_ASSET__bc2d7ce8__"